import { render } from "./statuses.vue?vue&type=template&id=088e02a4&scoped=true"
import script from "./statuses.vue?vue&type=script&lang=js"
export * from "./statuses.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=088e02a4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088e02a4"]])

export default __exports__